













import Proxyable from '@/mixins/proxyable';
import { Region } from '@/models/region';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

export default Proxyable.extend({
  name: 'RegionPicker',

  computed: {
    regions: get<Region[]>('region/regions')
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapActions({
      fetchRegions: 'region/fetchRegions'
    }),

    init() {
      if (!this.regions.length) {
        this.fetchRegions();
      }
    }
  }
});
